/* tslint:disable */

declare var Object: any;
export interface AnswerSequenceItemInterface {
  "sfdcId"?: string;
  "IsDeleted"?: boolean;
  "CreatedDate"?: Date;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedDate"?: Date;
  "LastModifiedById"?: string;
  "Name"?: string;
  "SystemModstamp"?: Date;
  "LastActivityDate"?: Date;
  "Answer_Sequence__c"?: string;
  "Answer_Text__c"?: string;
  "Is_Correct_Answer__c"?: boolean;
  "Item_Id__c"?: number;
  "Order__c"?: number;
  "Answer_Notes__c"?: string;
  "Is_Answer_Note_Required__c"?: boolean;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class AnswerSequenceItem implements AnswerSequenceItemInterface {
  "sfdcId": string;
  "IsDeleted": boolean;
  "CreatedDate": Date;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedDate": Date;
  "LastModifiedById": string;
  "Name": string;
  "SystemModstamp": Date;
  "LastActivityDate": Date;
  "Answer_Sequence__c": string;
  "Answer_Text__c": string;
  "Is_Correct_Answer__c": boolean;
  "Item_Id__c": number;
  "Order__c": number;
  "Answer_Notes__c": string;
  "Is_Answer_Note_Required__c": boolean;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: AnswerSequenceItemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AnswerSequenceItem`.
   */
  public static getModelName() {
    return "AnswerSequenceItem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AnswerSequenceItem for dynamic purposes.
  **/
  public static factory(data: AnswerSequenceItemInterface): AnswerSequenceItem{
    return new AnswerSequenceItem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AnswerSequenceItem',
      plural: 'AnswerSequenceItems',
      path: 'AnswerSequenceItems',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "SystemModstamp": {
          name: 'SystemModstamp',
          type: 'Date'
        },
        "LastActivityDate": {
          name: 'LastActivityDate',
          type: 'Date'
        },
        "Answer_Sequence__c": {
          name: 'Answer_Sequence__c',
          type: 'string'
        },
        "Answer_Text__c": {
          name: 'Answer_Text__c',
          type: 'string'
        },
        "Is_Correct_Answer__c": {
          name: 'Is_Correct_Answer__c',
          type: 'boolean'
        },
        "Item_Id__c": {
          name: 'Item_Id__c',
          type: 'number'
        },
        "Order__c": {
          name: 'Order__c',
          type: 'number'
        },
        "Answer_Notes__c": {
          name: 'Answer_Notes__c',
          type: 'string'
        },
        "Is_Answer_Note_Required__c": {
          name: 'Is_Answer_Note_Required__c',
          type: 'boolean'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
